@if (!hideFilters) {
  <section class="plan-filters">
    <accordion
      [header]="sortHeader"
      [isOpen]="true"
      data-test-id="planFilterAccordion"
    >
      <form-group
        (formCreated)="handleSortFormCreated()"
        [configs]="sortForms"
        [form]="filterForm"
        data-test-id="planSortFilterForm"
      >
      </form-group>
    </accordion>
    <accordion [header]="filterHeader" [isOpen]="openAccordion">
      <form-group
        (formCreated)="handleFormGroupCreated()"
        [configs]="filterForms"
        [form]="filterForm"
        data-test-id="planFilterAccordion"
      >
      </form-group>
      <div class="filters--buttons">
        <zip-button
          (zipButtonClicked)="clearFilters()"
          level="medium"
          [content]="filterResetButton"
          data-test-id="filterResetButton"
        >
        </zip-button>
        <zip-button
          (zipButtonClicked)="applyFilters()"
          level="high"
          [content]="filterApplyButton"
          data-test-id="filterApplyButton"
        >
        </zip-button>
      </div>
    </accordion>
    @if (!hideFilterFooter) {
      <footer class="plan-filters__footer" data-test-id="planFilterFooter">
        <div class="container">
          <div class="u-flex u-justifyBetween u-maxX">
            <zip-button
              level="low"
              content="Cancel"
              (zipButtonClicked)="clearFilters(); close()"
              data-test-id="footerFilterCloseButton"
            >
            </zip-button>
            <zip-button
              level="high"
              content="Apply"
              (zipButtonClicked)="applyFilters()"
              data-test-id="footerFilterApplyButton"
            >
            </zip-button>
          </div>
        </div>
      </footer>
    }
  </section>
}
